module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-mobile-oversea-title.1a47179c.png";